// Polyfill für requestIdleCallback (behebt Abstürze unter Apple Safari/iOS)
window.requestIdleCallback = window.requestIdleCallback || function (cb, options) {
  const timeout = (options && options.timeout) || 1;
  return setTimeout(function () {
    const start = Date.now();
    cb({
      didTimeout: false,
      timeRemaining: function () {
        return Math.max(0, 50 - (Date.now() - start));
      }
    });
  }, timeout);
};

window.cancelIdleCallback = window.cancelIdleCallback || function (id) {
  clearTimeout(id);
};

function getRoute(path) {
  const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  const cleanRoot = root.endsWith('/') ? root : root + '/';
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return cleanRoot + cleanPath;
}

class NativeDiscount {
  constructor(container) {
    this.container = container;
    this.input = container.querySelector('#native-discount-code');
    this.btn = container.querySelector('#native-discount-apply');
    this.msgBox = container.querySelector('#native-discount-message');
    this.msgText = container.querySelector('.msg-text');
    this.msgClose = container.querySelector('.close-msg');

    this.enableStacking = container.dataset.enableStacking === 'true';
    this.maxCodes = parseInt(container.dataset.maxCodes || 1, 10);

    // Instanz an Container heften für globalen Listener
    container.nativeDiscountInstance = this;

    this.init();
  }

  init() {
    if (this.btn && this.input) {
      this.btn.addEventListener('click', () => this.applyCode(this.input.value));
      this.input.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.applyCode(this.input.value);
        }
      });
    }

    if (this.msgClose) {
      this.msgClose.addEventListener('click', () => {
        this.msgBox.classList.add('hidden');
      });
    }

    // Wir nutzen jetzt einen globalen Event Listener (siehe unten), 
    // um App-Blockaden zu umgehen. Daher hier keine lokalen Listener für 'X'.
  }

  async applyCode(code) {
    code = code.trim();
    if (!code) return;

    // BUGSQUASH: data-code ist auf dem Button, nicht auf dem Tag!
    const appliedTags = Array.from(this.container.querySelectorAll('.remove-discount'))
      .map(btn => btn.dataset.code)
      .filter(c => c)
      .map(c => c.toUpperCase());

    if (appliedTags.includes(code.toUpperCase())) {
      this.input.value = '';
      return;
    }

    if (appliedTags.length >= this.maxCodes) {
      if (this.msgBox) this.msgBox.classList.remove('hidden');
      this.showError(`Maximal ${this.maxCodes} Rabattcode(s) erlaubt. Bitte lösche erst einen Code.`);
      return;
    }

    this.btn.classList.add('loading');
    this.btn.disabled = true;
    const originalText = this.btn.innerText;
    this.btn.innerText = 'Lade...';

    appliedTags.push(code);

    try {
      var sectionId = document.querySelector('main-cart') ? document.querySelector('main-cart').getAttribute('data-section-id') : null;
      var sectionsToBundle = [];
      if (sectionId) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
        if (!sectionsToBundle.includes(sectionId)) sectionsToBundle.push(sectionId);
      }

      const body = JSON.stringify({
        discount: appliedTags.join(','),
        sections: sectionsToBundle
      });

      // 1. Zuerst den Rabatt über Shopifys Standard-Endpoint im Hintergrund setzen (für Cookie-Persistenz in Safari & Chrome)
      const discountUrl = getRoute('discount/' + encodeURIComponent(code));
      await fetch(discountUrl, { mode: 'no-cors', credentials: 'include' }).catch(() => { });

      const updateUrl = getRoute('cart/update.js');
      const res = await fetch(updateUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: body,
        credentials: 'same-origin'
      });
      if (!res.ok) {
        throw new Error('Server antwortete mit Status ' + res.status + ' für ' + updateUrl);
      }
      const parsedState = await res.json();

      // Hidden Input für Checkout-Formular synchronisieren
      const discountInput = document.getElementById('cart-discount-input');
      if (discountInput) {
        discountInput.value = appliedTags.join(',');
      }

      if (window.theme && theme.pubsub) {
        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'native-discount', cart: parsedState });
      } else {
        window.location.reload();
      }
    } catch (fetchErr) {
      console.warn('Fehler beim Anwenden:', fetchErr);
      window.location.reload();
    } finally {
      this.btn.classList.remove('loading');
      this.btn.disabled = false;
      this.btn.innerText = originalText;
    }
  }

  async removeCode(code) {
    this.container.style.opacity = '0.5';
    console.log(`Lösche Rabattcode: ${code}`);

    try {
      const appliedTags = Array.from(this.container.querySelectorAll('.remove-discount'))
        .map(btn => btn.dataset.code)
        .filter(c => c && c.toUpperCase() !== code.toUpperCase());

      var sectionId = document.querySelector('main-cart') ? document.querySelector('main-cart').getAttribute('data-section-id') : null;
      var sectionsToBundle = [];
      if (sectionId) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
        if (!sectionsToBundle.includes(sectionId)) sectionsToBundle.push(sectionId);
      }

      const body = JSON.stringify({
        discount: appliedTags.join(','),
        sections: sectionsToBundle
      });

      // 1. Zuerst den Rabatt über Shopifys Standard-Clear-Endpoint im Hintergrund löschen (für Safari & Chrome Cookie-Sync)
      const clearUrl = getRoute('discount/clear');
      await fetch(clearUrl, { mode: 'no-cors', credentials: 'include' }).catch(() => { });

      const updateUrl = getRoute('cart/update.js');
      const res = await fetch(updateUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: body,
        credentials: 'same-origin'
      });
      if (!res.ok) {
        throw new Error('Server antwortete mit Status ' + res.status + ' für ' + updateUrl);
      }
      const parsedState = await res.json();

      // Hidden Input für Checkout-Formular synchronisieren
      const discountInput = document.getElementById('cart-discount-input');
      if (discountInput) {
        discountInput.value = appliedTags.join(',');
      }

      // 3. Zur absoluten Sicherheit die Cookies leeren
      document.cookie = "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      document.cookie = "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=." + window.location.hostname + ";";

      if (window.theme && theme.pubsub) {
        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'native-discount', cart: parsedState });
      } else {
        window.location.reload();
      }

    } catch (e) {
      console.error('Fehler beim Löschen des Rabatts:', e);
      window.location.reload();
    } finally {
      this.container.style.opacity = '1';
    }
  }

  // Die alte AJAX reloadCart Funktion wird nicht mehr benutzt, aber wir lassen sie zur Sicherheit drin, 
  // falls wir sie nochmal brauchen.
  async reloadCart(attemptedCode = null, isRemoval = false) {
    try {
      const cartUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart' : '/cart';
      const fetchUrl = cartUrl.replace('//', '/') + '?section_id=main-cart';
      console.log('Lade Warenkorb neu von:', fetchUrl);

      const res = await fetch(fetchUrl);
      const html = await res.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newContainer = doc.querySelector('.native-discount-container');
      if (newContainer) {
        console.log('Neuer Container gefunden, ersetze HTML...');
        this.container.innerHTML = newContainer.innerHTML;
        this.reInitElements();

        // After reload, check if the attempted code is in the applied tags
        if (attemptedCode) {
          const appliedTags = Array.from(this.container.querySelectorAll('.discount-tag')).map(t => t.dataset.code.toUpperCase());
          if (appliedTags.includes(attemptedCode.toUpperCase())) {
            this.showSuccess(`Rabattcode '${attemptedCode}' angewendet!`);
            // Trigger cart update event so free shipping bar and others can update
            document.dispatchEvent(new CustomEvent('cart:updated'));
          } else {
            this.showError(`Rabattcode '${attemptedCode}' ungültig oder Bedingungen nicht erfüllt.`);
          }
        } else if (isRemoval) {
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }
      }
    } catch (e) {
      console.error(e);
    } finally {
      if (this.btn) {
        this.btn.classList.remove('loading');
        this.btn.disabled = false;
      }
      this.container.style.opacity = '1';
    }
  }

  reInitElements() {
    this.input = this.container.querySelector('#native-discount-code');
    this.btn = this.container.querySelector('#native-discount-apply');
    this.msgBox = this.container.querySelector('#native-discount-message');
    this.msgText = this.container.querySelector('.msg-text');
    this.msgClose = this.container.querySelector('.close-msg');
    this.init();
  }

  showSuccess(msg) {
    if (!this.msgBox) return;
    this.msgBox.className = 'text-sm px-3 py-2 mt-2 rounded-sm bg-green-100 text-green-800 flex justify-between items-center';
    this.msgText.textContent = msg;
    this.input.value = '';
  }

  showError(msg) {
    if (!this.msgBox) return;
    this.msgBox.className = 'text-sm px-3 py-2 mt-2 rounded-sm bg-red-100 text-red-800 flex justify-between items-center';
    this.msgText.textContent = msg;
  }
}

function initNativeDiscount() {
  const container = document.getElementById('native-discount-container');
  if (container) {
    container.dataset.initialized = 'true';
    window.nativeDiscountGlobal = new NativeDiscount(container);
    container.nativeDiscountInstance = window.nativeDiscountGlobal;
    console.log('🚀 MATRIX HACK AKTIVIERT! (Version 3.0) - Radar läuft!');
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initNativeDiscount);
} else {
  initNativeDiscount();
}

// Wenn der Theme-eigene Cart updatet (z.B. Mengenänderung), das Discount-Modul neu initialisieren
document.addEventListener('cart:updated', () => {
  setTimeout(() => {
    initNativeDiscount();
  }, 100);
});

// GLOBALER RADAR ZUR FEHLERSUCHE
window.addEventListener('click', (e) => {
  // Radar: Was genau wurde angeklickt?
  console.log('🎯 RADAR: Du hast geklickt auf:', e.target.tagName, e.target.className);

  const btn = e.target.closest('.remove-discount');
  if (btn) {
    // Klick sofort im Keim ersticken!
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    console.log('⚡ X-Button CLICK erfolgreich abgefangen! App wurde ausgetrickst.');

    const tag = btn.closest('.discount-tag');
    const container = btn.closest('.native-discount-container');
    // BUGSQUASH: data-code ist auf dem Button, nicht auf dem Tag!
    const code = btn.dataset.code || (tag ? tag.dataset.code : '');

    if (code && container && container.nativeDiscountInstance) {
      container.nativeDiscountInstance.removeCode(code);
    } else {
      console.error('Konnte Rabattcode oder Instanz nicht finden:', code, container);
    }
  } else {
    // Wenn es NICHT der remove-discount Button war, aber in der Nähe ist:
    const tagContainer = e.target.closest('.discount-tag');
    if (tagContainer) {
      console.log('⚠️ RADAR WARNUNG: Du hast den Rabatt-Tag angeklickt, aber NICHT den .remove-discount Button! Der Klick landete auf:', e.target);
    }
  }
}, true);


// GLOBALER CHECKOUT INTERCEPTOR
// Zwingt Shopify, den Rabatt aus der Kassen-Session zu werfen, wenn er gelöscht wurde.
window.addEventListener('click', (e) => {
  const btn = e.target.closest('button[name="checkout"], input[name="checkout"], .checkout-button, [href*="/checkout"]');
  if (btn) {
    // Da Shopify beim Re-Rendern den versteckten Input manchmal wieder mit dem alten (klebenden) Code füllt,
    // schauen wir direkt auf das, was der Kunde sieht: Gibt es sichtbare Rabatt-Tags?
    const container = document.querySelector('.native-discount-container');
    let hasActiveDiscount = false;
    
    if (container) {
      const activeTags = container.querySelectorAll('.remove-discount');
      hasActiveDiscount = activeTags.length > 0;
    } else {
      const discountInput = document.getElementById('cart-discount-input');
      hasActiveDiscount = discountInput && discountInput.value.trim() !== '';
    }

    // Wenn KEIN Rabatt aktiv ist (Kunde sieht keinen, oder Input ist leer)
    if (!hasActiveDiscount) {
      e.preventDefault();
      console.log('⚡ Checkout abgefangen: Kein Rabatt aktiv. Erzwinge /checkout?discount= zur Bereinigung der Session.');
      
      const form = btn.form || btn.closest('form');
      
      // Button visuell deaktivieren, aber Text beibehalten
      btn.style.pointerEvents = 'none';
      btn.style.opacity = '0.5';

      if (form) {
        const formData = new FormData(form);
        formData.delete('checkout'); // Verhindert den sofortigen Shopify-Redirect
        
        fetch(getRoute('cart/update.js'), {
          method: 'POST',
          body: formData
        }).then(() => {
          window.location.href = getRoute('checkout?discount=');
        }).catch(() => {
          window.location.href = getRoute('checkout?discount=');
        });
      } else {
        window.location.href = getRoute('checkout?discount=');
      }
    }
  }
}, true);
